import * as Sentry from '@sentry/browser';
import settings from '@hydra/utils/settings';
import escapeRegExp from 'lodash/escapeRegExp';
import { Integrations } from '@sentry/tracing';

const IS_WOORANK_DOT_COM_REGEX = /^https:\/\/(?:www\.)?woorank\.com\//;
const IGNORED_ERROR = /(?:UC_NEWS_PAUSE_ALL_VIDEOS|UC_RM_restoreMarkScrollTop)/;

Sentry.init({
  dsn: settings.get('sentryDsn'),
  release: settings.get('sentryRelease'),
  allowUrls: [
    IS_WOORANK_DOT_COM_REGEX,
    new RegExp(`^${escapeRegExp(settings.get('cdnUrl'))}`)
  ],
  integrations: [
    new Integrations.BrowserTracing({
      tracingOrigins: [IS_WOORANK_DOT_COM_REGEX, 'localhost', /^\//]
    })
  ],
  enabled: IS_WOORANK_DOT_COM_REGEX.test(window.location.href),
  tracesSampleRate: 0.1,
  beforeSend (event, hint) {
    const error = hint && hint.originalException;
    const msg = error && (typeof error === 'string' ? error : error.message);
    if (msg && IGNORED_ERROR.test(msg)) {
      event.fingerprint = ['ignored'];
    }
    return event;
  }
});

Sentry.setUser({ id: settings.get('userId') });
